export const liveGamesContentController = {
  initial: 'off',
  states: {
    off: {
      on: {
        LAYOUT_CHANGE_END: {
          target: 'on',
          cond: 'isControllerEnabled_liveGamesContent',
        },
      },
    },
    on: {
      type: 'parallel',
      states: {
        content: {
          initial: 'reloading',
          states: {
            idle: {
              on: {
                RELOAD_CATEGORIES: 'reloading',
                LAYOUT_CHANGE_END: 'reloading',
                RENDER_BINGO_GAMES: 'reloading', // Handle session-triggered renders
              },
            },
            reloading: {
              invoke: {
                src: 'getLiveGamesContent',
                onDone: {
                  target: 'idle',
                  actions: [
                    {
                      type: 'batchLayoutOperations',
                      data: '$event.data.updates',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                  ],
                },
              },
              on: {
                RELOAD_CATEGORIES: 'reloading',
              },
            },
          },
        },
        bingoGames: {
          initial: 'checking',
          states: {
            checking: {
              always: [
                { target: 'fetching', cond: 'shouldFetchBingoGames' },
                { target: 'idle' },
              ],
            },
            idle: {
              on: {
                LAYOUT_CHANGE_END: [
                  { target: 'fetching', cond: 'shouldFetchBingoGames' },
                  { target: 'idle' },
                ],
                FETCH_BINGO_GAMES: [
                  { target: 'fetching', cond: 'shouldFetchBingoGames' },
                  { target: 'idle' },
                ],
                BINGO_GAMES_UPDATED: [
                  { target: 'fetching', cond: 'shouldFetchBingoGames' },
                  { target: 'idle' },
                ],
              },
            },
            fetching: {
              invoke: {
                src: 'fetchBingoGames',
                onDone: {
                  target: 'idle',
                  actions: [
                    'saveFetchedBingoGames',
                    'watchBingoGamesTimer',
                    'categories_reload',
                  ],
                },
              },
            },
          },
        },
      },
      on: {
        LAYOUT_CHANGE_END: {
          target: 'off',
          cond: 'isControllerDisabled_liveGamesContent',
        },
      },
    },
  },
};
